import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { navLinks } from "@/mocks/siteData";

export default function Navbar() {
  const { pathname } = useLocation();
  const isHome = pathname === "/";
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  const transparent = isHome && !scrolled && !open;

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        transparent
          ? "bg-foreground-950 border-b-2 border-foreground-950"
          : "bg-background-50 border-b-2 border-foreground-950"
      }`}
    >
      <nav className="h-[68px] px-4 md:px-8 flex items-center justify-between">
        <Link to="/" className="flex items-center cursor-pointer">
          <img
            src={transparent ? "/logo-w.png" : "/logo.png"}
            alt="FX Order Types"
            width={180}
            className="h-auto w-[180px]"
          />
        </Link>

        <ul className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => {
            const active = pathname === link.to;
            return (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className={`px-3 py-2 font-label text-[11px] uppercase tracking-[0.14em] transition-colors cursor-pointer border-2 ${
                    active
                      ? "bg-primary-500 border-foreground-950 text-foreground-950"
                      : transparent
                        ? "border-transparent text-background-200 hover:text-primary-500"
                        : "border-transparent text-foreground-600 hover:text-foreground-950"
                  }`}
                >
                  {link.label}
                </Link>
              </li>
            );
          })}
        </ul>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
            className={`lg:hidden w-10 h-10 flex items-center justify-center border-2 cursor-pointer ${
              transparent
                ? "border-background-50 text-background-50"
                : "border-foreground-950 text-foreground-950"
            }`}
          >
            <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="lg:hidden border-t-2 border-foreground-950 bg-background-50 px-4 pb-4 pt-2">
          <ul className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  onClick={() => setOpen(false)}
                  className={`block px-4 py-3 font-label text-xs uppercase tracking-[0.14em] border-2 cursor-pointer ${
                    pathname === link.to
                      ? "bg-primary-500 border-foreground-950 text-foreground-950"
                      : "border-transparent text-foreground-700 hover:border-foreground-950"
                  }`}
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}